const STRIPE_PUBLISHABLE = process.env.NODE_ENV === 'production'
  ? 'pk_live_MY_PUBLISHABLE_KEY'
  : 'pk_test_FnGbY0qD0mRH5bM9fssEyKiE00sqBowRGQ';

export default STRIPE_PUBLISHABLE;
